import React from "react";
import "./App.css";
import "./Skins.css"
import { useStateValue } from "./StateProvider";

function Skins({id}) {
  const [{ skins }] = useStateValue();
  const[{players}]= useStateValue();

  const getSkins = (id) => {
    const skinHoles = skins.filter((s) => s.Winner  === id);
    const total = skinHoles?.reduce((totalSkins, s) => totalSkins + s.Amount,0);
    return total;
  };

  return (
    <div className="skins">
      {(players.find((p)=>p.id===id)).inGroupSkins?   
      <table>
        <thead>
        <tr>
          <th>Skins</th>
        </tr>
        </thead>
      <tbody>
      <tr>
          <td className="skins__Won">{getSkins(id)}</td>
        </tr>
      </tbody>
   
      </table> :null}
    </div>
  );
}

export default Skins;
